import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useAcceptVerifyData = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onAcceptVerifyDataError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while accepting verification data.',
        );
    };

    const onAcceptVerifyDataSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message || 'Verification data accepted successfully');
        callbackFn();
    };

    const acceptVerifyData = (driverId: string, callbackFn: () => void) => {

        const url: HttpConfig = {
            url: `ba/v1/drivers/onboarding/update-status/${driverId}`,
            method: 'put',
            data: { status: 'Confirmed' },
        };

        request(url, onAcceptVerifyDataSuccess(callbackFn), setLoading, onAcceptVerifyDataError);
    };

    return { acceptVerifyData, loading };
};

export default useAcceptVerifyData;
